import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const { t } = useTranslation();
  const location = useLocation();

  const schemaItems = [
    { '@type': 'ListItem' as const, position: 1, name: t('breadcrumb.home'), item: window.location.origin + '/' },
    ...items.map((item, index) => ({
      '@type': 'ListItem' as const,
      position: index + 2,
      name: item.label,
      item: item.path ? window.location.origin + item.path : undefined,
    })),
  ];

  return (
    <>
      <nav aria-label="Breadcrumb" className="w-full px-4 md:px-6 py-3 bg-background-100/70">
        <ol className="flex items-center flex-wrap gap-1 text-sm max-w-[1400px] mx-auto">
          <li>
            <Link to="/" className="text-foreground-500 hover:text-primary-500 transition-colors">
              {t('breadcrumb.home')}
            </Link>
          </li>
          {items.map((item, index) => (
            <li key={index} className="flex items-center gap-1">
              <span className="text-foreground-400 mx-1">/</span>
              {item.path && index < items.length - 1 ? (
                <Link to={item.path} className="text-foreground-500 hover:text-primary-500 transition-colors">
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-800 font-medium">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: schemaItems,
          }),
        }}
      />
    </>
  );
}